// Self-update avatar-cli qua npm global install.
//
// `avatar update [--tag <dist-tag>]`:
//   1. npm view @nalvietnam/avatar-cli@<tag> version  → version đích của tag
//   2. So với version đang chạy (readCliVersion) — trùng → đã mới nhất, dừng.
//   3. npm i -g @nalvietnam/avatar-cli@<tag>          → stdio inherit (user thấy tiến trình)
//
// KHÔNG semver-compare: đích = "đúng bản mà dist-tag đang trỏ" (cho phép cả
// chuyển kênh next→latest, kể cả khi đó là downgrade số — user chủ đích chọn tag).
// Pure helpers (build args / parse output) tách riêng để unit test không cần mock.

import { spawnSync } from "node:child_process";
import { detectHostPlatform } from "./detect-host-platform.js";

export const AVATAR_CLI_PACKAGE_NAME = "@nalvietnam/avatar-cli";

// npm trên Windows là npm.cmd → cần shell. POSIX chạy thẳng.
function npmNeedsShell(): boolean {
  return detectHostPlatform() === "win32";
}

export function buildNpmViewVersionArgs(distTag: string): string[] {
  return ["view", `${AVATAR_CLI_PACKAGE_NAME}@${distTag}`, "version"];
}

export function buildNpmGlobalInstallArgs(distTag: string): string[] {
  return ["install", "-g", `${AVATAR_CLI_PACKAGE_NAME}@${distTag}`];
}

// `npm view` in version + newline (đôi khi kèm dòng notice) → lấy dòng cuối
// khác rỗng có dạng version. Output rác / rỗng → null.
export function parseNpmViewVersionOutput(stdout: string): string | null {
  const lines = stdout
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);
  const last = lines.at(-1) ?? "";
  return /^\d+\.\d+\.\d+(-[\w.]+)?$/.test(last) ? last : null;
}

// Version mà dist-tag đang trỏ trên registry. null = không lấy được
// (offline / npm thiếu / tag không tồn tại / timeout) — caller báo user, không crash.
export function fetchVersionForDistTag(distTag: string): string | null {
  const r = spawnSync("npm", buildNpmViewVersionArgs(distTag), {
    encoding: "utf-8",
    shell: npmNeedsShell(),
    timeout: 5000, // 5s — tránh treo vô hạn khi npm registry chậm/proxy treo
  });
  // status=null khi process bị kill bởi timeout (SIGTERM) hoặc không spawn được.
  // status!==0 bắt exit code lỗi. Cả hai → fail-soft, trả null.
  if (r.status === null || r.status !== 0 || !r.stdout) return null;
  return parseNpmViewVersionOutput(r.stdout);
}

// Cài bản mới. stdio inherit để user thấy progress + lỗi quyền (EACCES) thật.
// Trả exit code (0 = ok).
export function runNpmGlobalInstall(distTag: string): number {
  const r = spawnSync("npm", buildNpmGlobalInstallArgs(distTag), {
    stdio: "inherit",
    shell: npmNeedsShell(),
  });
  return r.status ?? 1;
}
